module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrainshowers-721e8704aa7fb642cc5de171adeb2b60.png";